import { Music, Users, Calendar, Search, MapPin, Heart } from 'lucide-react';
import SEOLandingPage from '../../components/seo/SEOLandingPage';

export default function MusikerFindenBern() {
  return (
    <SEOLandingPage
      title="Musiker finden in Bern | jamnation - Berner Musikszene"
      description="Finde talentierte Musiker in Bern und Umgebung. Gitarristen, Schlagzeuger, Bassisten, Sänger für deine Band. Vernetze dich mit der Berner Musikszene auf jamnation."
      h1="Musiker finden in Bern"
      heroText="Entdecke die lebendige Musikszene von Bern. Finde lokale Musiker für deine Band, dein Projekt oder spontane Jam-Sessions in der Hauptstadt und Umgebung."
      keywords={[
        'musiker finden bern',
        'musiker suchen bern',
        'band musiker bern',
        'gitarrist bern',
        'schlagzeuger bern',
        'bassist bern',
        'sänger bern',
        'musikszene bern',
        'jam session bern',
      ]}
      locationName="Bern & Region"
      ctaButtons={[
        {
          text: 'Berner Musiker entdecken',
          link: '/musicians',
          primary: true,
        },
        {
          text: 'Berner Bands',
          link: '/bands',
        },
      ]}
      features={[
        {
          icon: MapPin,
          title: 'Lokale Musikszene',
          description:
            'Vernetze dich mit Musikern aus Bern, Köniz, Ostermundigen, Muri bei Bern und der ganzen Region. Die Berner Szene wartet auf dich!',
          link: '/musicians',
        },
        {
          icon: Users,
          title: 'Vielfältige Community',
          description:
            'Von Rock und Punk im ISC bis zu Jazz im Marians Jazzroom – Berns Musikszene ist vielfältig. Finde Gleichgesinnte für dein Genre.',
          link: '/musicians',
        },
        {
          icon: Music,
          title: 'Alle Instrumente',
          description:
            'Gitarre, Bass, Drums, Keys, Vocals und mehr. Finde genau den Musiker, den deine Band braucht – direkt aus Bern.',
          link: '/musicians',
        },
        {
          icon: Calendar,
          title: 'Berner Events',
          description:
            'Sieh dir an, wo Berner Bands auftreten. Von der Reitschule bis zum Bierhübeli – entdecke Live-Musik in deiner Stadt.',
          link: '/agenda',
        },
        {
          icon: Search,
          title: 'Gezielte Suche',
          description:
            'Filtere nach Erfahrung, Genre und Verfügbarkeit. Finde schnell den perfekten Bandkollegen für dein Projekt in Bern.',
          link: '/musicians',
        },
        {
          icon: Heart,
          title: 'Kostenlos vernetzen',
          description:
            'Komplett kostenlose Nutzung. Erstelle dein Profil, kontaktiere Musiker und werde Teil der Berner Musikcommunity.',
          link: '/become-musician',
        },
      ]}
      teaserSection={{
        title: 'Was du auf jamnation alles tun kannst',
        description:
          'jamnation ist mehr als nur eine Musikersuche. Hier kannst du deine Band präsent machen und dich mit der ganzen Berner Musikszene vernetzen.',
        items: [
          'Erstelle ein Profil für deine Band und zeige, was ihr drauf habt',
          'Veröffentliche bevorstehende Konzerte und erreiche mehr Publikum',
          'Teile Geschichten und Erlebnisse aus dem Bandalltag',
          'Lade Hörproben und Songs hoch, damit Fans deine Musik entdecken',
          'Vernetze dich mit anderen Musikern und Bands aus der Region',
          'Werde als Band für Events und private Feiern gebucht',
        ],
      }}
      seoTeaser={{
        title: 'Die Berner Musikszene vereint',
        description:
          'Ob du einen Gitarristen für deine Rock-Band suchst, einen Drummer für dein Jazz-Projekt brauchst oder als Bassist neue musikalische Herausforderungen suchst – in Bern und Umgebung findest du auf jamnation die passenden Musiker. Unsere Plattform verbindet die gesamte Berner Musikszene: von der Reitschule über das Bierhübeli bis zu den zahlreichen Proberäumen in Köniz und Ostermundigen. Registriere dich kostenlos, erstelle dein Musikerprofil mit Soundbeispielen und werde Teil der aktivsten Musikcommunity der Hauptstadt. Egal ob Hobby-Musiker oder Profi, ob für bezahlte Gigs oder kreative Sessions – hier findest du Gleichgesinnte, die deine Leidenschaft für Musik teilen.',
      }}
      faqItems={[
        {
          question: 'Wie finde ich Musiker speziell in Bern?',
          answer:
            'Nutze die Standortfilter in der Musikersuche und wähle Bern oder einen bestimmten Stadtteil aus. So siehst du nur Musiker aus deiner Region.',
        },
        {
          question: 'Welche Musikstile sind in Bern vertreten?',
          answer:
            'Bern hat eine sehr vielfältige Szene: Rock, Punk, Metal, Hip-Hop, Jazz, Reggae, Indie und vieles mehr. Du findest Musiker für praktisch jedes Genre.',
        },
        {
          question: 'Kann ich auch für einmalige Projekte Musiker finden?',
          answer:
            'Ja! Viele Musiker in Bern sind offen für Projekte, Sessions oder einmalige Auftritte. Schreib einfach in deiner Anfrage, was du planst.',
        },
        {
          question: 'Gibt es auch erfahrene Profi-Musiker auf jamnation?',
          answer:
            'Absolut! Auf jamnation findest du sowohl ambitionierte Hobby-Musiker als auch erfahrene Profis aus der Berner Szene.',
        },
        {
          question: 'Wie kann ich mein eigenes Musikerprofil für Bern erstellen?',
          answer:
            'Klicke auf "Musiker werden", fülle dein Profil aus, gib Bern als Standort an und lade Soundbeispiele hoch. Fertig!',
        },
      ]}
    />
  );
}
